import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { PROJECT_API } from "../apiRoutes";

interface UseGetDependencyTreeProps {
  projectId: string;
  taskId: string;
  filter?: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getDependencyTree = async (taskId: string, projectId: string, filter: any) =>
  await axiosAuth.get(`${PROJECT_API}/${projectId}/tasks/${taskId}/dependency-tree?${new URLSearchParams(filter).toString()}`);

const useGetDependencyTree = ({
  taskId,
  projectId,
  filter,
  queryParams,
}: UseGetDependencyTreeProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["dependency-tree", taskId],
    queryFn: () => getDependencyTree(taskId, projectId, filter),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetDependencyTree;
